import { BlockSupportModal } from '@components/Settings/BlockSupport/BlockSupport';
import { StylesEditorModal } from '@components/Settings/CodeEditor/StylesEditorModal';
import { DesignTokenModal } from '@components/Settings/DesignToken/DesignTokenModal';
import { RecoverModal } from '@components/Settings/Recover/RecoverModal';

const BlockbiteSidebar = () => {
  return (
    <div className="flex flex-col gap-2 p-4">
      <BlockSupportModal />
      <DesignTokenModal />
      <StylesEditorModal />
      <RecoverModal />
    </div>
  );
};

export default BlockbiteSidebar;
